<template>
  <BQdtCard
    name="complaintsAnalyticsTitle"
    type="header-item"
  />
</template>

<script>
import { BQdtCard } from '@/components/blocks'

export default {
  name: 'AnalyticsHeader',

  components: { BQdtCard },
}
</script>
